


















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import NominaTransaccion from "@/models/tarjeta/nomina-transaccion.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import helpers from "@/helpers/helper";
import BTableConfig from '../../core/BTableConfig/BTableConfig';
@Component
export default class MovimientoTarjetaTable extends GenericBTable<
  NominaTransaccion
> {
  @Prop() readonly title!: string;
  @Prop() readonly whereParams!: string;
  @Prop() readonly tarjeta!: string;
  @Prop() readonly cedula!: string;
  @Prop() readonly hideFilters!: boolean;
  @Prop() readonly checkable!: boolean;

  tipo = "A";
  fechaDesde: Date | null = null;
  fechaHasta: Date | null = null;
  sync: boolean = false;

  constructor() {
    super();
    this.fechaDesde = null;
    this.fechaHasta = null;
  }
  get hayTarjeta() {
    return !!this.tarjeta;
  }
  created() {
    this.setupTable();
    this.formatColumns();
  }

  mounted() {
    if (!this.sync) {
      this.syncTarjeta();
    }
  }
  setupTable() {
    this.tableConfig.controller = "tarjeta";
    this.tableConfig.resource = `movimientos`;
    this.tableConfig.whereParams = this.queries;
    this.tableConfig.activeActions = false;
    this.tableConfig.loadOnMount = false; //this.hayTarjeta;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.style.narrowed = true;
    this.tableConfig.detailed = true;
    this.tableConfig.pagination.perPage = 5;
    this.tableConfig.emptyText = "No hay movimientos de tarjeta";
    this.tableConfig.sorting.field = "fechaTransaccion";
    this.tableConfig.customEmptyTemplate = true; //this.hayTarjeta === false;
    this.$emit('update:config', this.tableConfig);
  }
  formatColumns() {
    let monto = new BTableColumn("simboloMonto", "Monto");
    monto.customTemplate = true;
    let subsidio = new BTableColumn("subsidioFull", "Subsidio", false);
    let fecha = new BTableColumn("fechaTransaccion", "Fecha");
    let tarjeta = new BTableColumn("tarjeta", "Número de tarejta");
    fecha.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(monto, subsidio, fecha);
  }

  get queries() {
    let where = String();
    let queries = [];
    queries.push(`tarjeta="${this.tarjeta}"`);
    if (this.tipo === "N") queries.push(`nominaId > 0`);
    if (this.tipo === "T") queries.push(`transaccionId > 0`);
    if (this.fechaDesde)
      queries.push(`fechaTransaccion >= "${moment(this.fechaDesde).format()}"`);
    if (this.fechaHasta)
      queries.push(`fechaTransaccion <= "${moment(this.fechaHasta).format()}"`);

    where = queries.join("&");
    if (this.whereParams) where += this.whereParams;
    return where;
  }

  @Watch("tarjeta", { immediate: true })
  onTarjetaChange(value: string | undefined) {
    if (value) this.buscar();
  }
  buscar() {
    if (this.tarjeta && this.tarjeta.length > 10) {
      this.tableConfig.whereParams = this.queries;
      if (this.tableConfig.reload) this.tableConfig.reload();
    }
  }

  syncTarjeta() {
    if (this.cedula && this.tarjeta && this.tarjeta.length > 10) {
      let cedula = this.cedula;
      let tarjeta = this.tarjeta;
      let p = {
        cedula,
        tarjeta
      };
      this.tableConfig.loading = true;
      this.tableConfig
        .repository()
        .client.getAsync("SyncOrGetAllMovimientosTarjeta", p)
        .then(x => {
          this.tableConfig.loading = false;
          this.buscar();
        })
        .catch(e => {
          this.tableConfig.loading = false;
          this.operationFailedErrors(e);
          this.buscar();
        });
    }
  }
  limpiar() {
    this.tipo = "A";
    this.fechaDesde = null;
    this.fechaHasta = null;
  }
}
